import { Button, Container, TextField, Typography, Backdrop, CircularProgress } from "@mui/material";
import React from "react";
import { Context } from "../../App";
import { useNavigate } from "react-router-dom";


export default function LoginForm({onLogin}) {
    const navigate = useNavigate();
    const { setIsConnected } = React.useContext(Context);
    const [loading, setLoading] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [mail, setMail] = React.useState('');
    const [password, setPassword] = React.useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);

        console.log(`${process.env.REACT_APP_API_URL}/adm/login`);

        fetch(`${process.env.REACT_APP_API_URL}/adm/login`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${btoa(mail + ':' + password)}`
            }
        })
        .then(async response => {
            if (!response.ok) {
                const text = await response.text();
                setMsg((response.status!==500 ? text : null) || 'Erreur lors de la connexion. Veuillez réessayer.');
            }else {
                sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                const json = await response.json();
                sessionStorage.setItem('user', JSON.stringify(json));
                setIsConnected(true);
                setMsg('');
                !!onLogin? onLogin() : navigate('/')
            }
            setLoading(false);
        })
        .catch(error => {
            setLoading(false);
            console.error('Erreur lors de la connexion :', error);
            alert('Une erreur est survenue. Veuillez réessayer plus tard.');
        });
    }

    return <Container component='form' onSubmit={handleSubmit} maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: 4, rowGap:2, minWidth: '400px' }}>
        <Typography variant="h4" align="center" sx={{ mb: 2 }}>Je me connecte</Typography>

        { msg && <Typography variant="body1" color="error" sx={{ mb: 2 }}>{msg}</Typography>}

        <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required
        onBlur={() => setMail(mail.trim())}
        onChange={(e) => setMail(e.target.value)} />

        <TextField fullWidth type="password" label="Mot de passe" variant="outlined" value={password} required
        onChange={(e) => setPassword(e.target.value)} />

        <Button type="submit" variant="contained" color="primary" sx={{alignSelf: 'center', px: 5, mb: 2}}>Connexion</Button>
        
        <Backdrop open={loading}><CircularProgress/></Backdrop>

    </Container>
}